import React from 'react';
import DateFormatter from '../../shims/date-formatter.js';
import "./sass/boss-option.scss";

function BossOption({
  selected=true,
  select=()=>{},
  details,
  bossEligible = false
}) {

  const {
    estimatedStartDeliveryDate,
    estimatedEndDeliveryDate,
    bossEstimatedShippingStartDate,
    bossEstimatedShippingEndDate,
    isBackordered,
    backorderExpectedShipDate,
    isPurchasableInLocalStoreBoss,
    isZeroStockInLocalStoreBoss,
    bossShippingExclusionApplies,
    store,
  } = details;


  //This is not needed:
  // const backorderExpectedShipDate = "";

  const enabled =
    details.enabled &&
      (!(details.installSelected || details.quantityError) ||
      (bossEligible && !details.bossShippingExclusionApplies));

  const getExcludedStateName = (store={}) => {
    const stateCode = store.statecode;
    if(stateCode==="HI"){
      return "Hawaii";
    }else if(stateCode==="AK"){
      return "Alaska";
    }else{
      return stateCode;
    }
  }

  let cardClasses = "pickupTile card card-container card-background ";
  cardClasses+=(selected?"card-selected ":"card-unselected ");
  cardClasses+=(enabled?"card-enabled ":"card-unselected ");
  let dateRange = estimatedStartDeliveryDate !== estimatedEndDeliveryDate;

  let expectItDate = dateRange? DateFormatter.convertLongMonthToShort(estimatedStartDeliveryDate)+ ' - ' +
    DateFormatter.convertLongMonthToShort(estimatedEndDeliveryDate) : "";

  let bossDateRange = bossEstimatedShippingStartDate !== bossEstimatedShippingEndDate;
  let bossExpectItDate = bossDateRange? DateFormatter.convertLongMonthToShort(bossEstimatedShippingStartDate)+ ' - ' +
    DateFormatter.convertLongMonthToShort(bossEstimatedShippingEndDate) : "";

  return (
    <div className={cardClasses} onClick={()=>{if(enabled){select('PICKUP')}}}>
      <div className={"ship-to-store__wrapper " + (enabled?"":"ship-to-store__wrapper--disabled")}>
        <div className={"ship-to-store__icon pick-up-" + (enabled?"true":"false")}/>
        <div className="tile-heading ship-to-store__heading dai_tileHeading">Ship to Store</div>
        {enabled && ((dateRange && !(isBackordered && !backorderExpectedShipDate)) ||
            (isPurchasableInLocalStoreBoss || isZeroStockInLocalStoreBoss)) 
            && !isBackordered &&
          <div className="tile-message ship-to-store__message">
            <div className="">
              <span className="dai_tileMessage">
                Pickup
              </span>
            </div>
          </div>
        }
        {enabled && isBackordered &&
          <div className="tile-message ship-to-store__message dai_tileMessage">Backordered</div>
        }    
        {!(isBackordered && !backorderExpectedShipDate) 
          && !bossShippingExclusionApplies 
          && (bossExpectItDate || expectItDate) &&
          <span className="tile-message tile-date ship-to-store__message ship-to-store__message--bold dai_tileDate">
            {(isPurchasableInLocalStoreBoss || isZeroStockInLocalStoreBoss) ?
              bossExpectItDate:
              expectItDate
            }
          </span>
        }
        {!enabled && !bossShippingExclusionApplies &&
          <div className="ship-to-store__message-wrapper">
            <div className="tile-message ship-to-store__message ship-to-store__message--boss-unavailable dai_tileMessage">
              Not available for this item
            </div>
          </div>
        }
        {!enabled && bossShippingExclusionApplies &&
          <div className="ship-to-store__message-wrapper">
            <div className="tile-message ship-to-store__message dai_tileMessage">
              Not available in {getExcludedStateName(store)}
            </div>
            <div className="u__center">
              <span className="u__text--success dai_tilePrice">
                <div className="dai_pickupTileMessage_checkNearby change-store">
                  <a href="#" className="u__default-link store-inventory-finder-trigger">
                    Change Store
                  </a>
                </div>
              </span>
            </div>
          </div>
        }
      </div>
      {enabled &&
        <div className="fulfillment__price-wrapper card-messaging-bottom">
          <span className="u__text--success dai_tilePrice">
            FREE
          </span>
        </div>
      }
    </div>
  );
}

export default BossOption;
